import React, { useState, useRef, useEffect } from "react";
import { generateId } from "../../../Utils/generatorUtils";
import Chevron from "../../../Theming/icons/Chevron/index";
import "./index.css";
const Accordion = ({
  initCollapsed,
  title,
  children,
  icon,
  isAlert,
  onToggle,
  id
}) => {
  const [isCollapsed, setIsCollapsed] = useState(initCollapsed);
  const [height, setHeight] = useState(null);
  const elementRef = useRef([]);
  const [animationRequest, setAnimationRequest] = useState(null);
  const [accordionUnlocked, setAccordionUnlocked] = useState(false);
  const [uniqueId] = useState(generateId()); // Use state for unique id to avoid values update on component rerendering
  const buttonId = id ? id : uniqueId + "-btn";
  const containerId = id ? id : uniqueId + "-container";
  const assignRef = el => {
    if (el) {
      elementRef.current = el;
    }
  };
  const toggleAccordion = () => {
    window.cancelAnimationFrame(animationRequest);
    setAccordionUnlocked(true);
    setIsCollapsed(!isCollapsed);
    if (onToggle) {
      onToggle();
    }
  };
  useEffect(() => {
    if (!initCollapsed) {
      setHeight("auto");
    }
  }, [initCollapsed]);
  useEffect(() => {
    let start = null;
    const step = timestamp => {
      let progress;
      if (!start) {
        start = timestamp;
      }
      progress = timestamp - start;
      if (isCollapsed) {
        if (progress > 10) {
          setHeight("");
        } else {
          setHeight(elementRef.current.scrollHeight);
        }
      } else if (progress < 500) {
        setHeight(elementRef.current.scrollHeight);
      } else {
        setHeight("auto");
      }
      if (progress < 500) {
        setAnimationRequest(window.requestAnimationFrame(step));
      }
    };
    if (children && accordionUnlocked) {
      setHeight(elementRef.current.scrollHeight);
      setAnimationRequest(window.requestAnimationFrame(step));
    }
  }, [isCollapsed, accordionUnlocked, children]);
  if (!title || !children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `accordion ${isCollapsed ? "accordion--collapsed" : ""}`
  }, /*#__PURE__*/React.createElement("h3", {
    role: isAlert ? "alert" : "heading",
    "aria-level": isAlert ? null : "3",
    className: "accordion__heading"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: toggleAccordion,
    className: "qa-accordion__title accordion__title",
    "aria-expanded": !isCollapsed,
    "aria-disabled": isCollapsed,
    "aria-controls": containerId,
    id: buttonId
  }, icon, /*#__PURE__*/React.createElement("span", {
    className: "accordion__title-text"
  }, title), /*#__PURE__*/React.createElement(Chevron, {
    className: "accordion__icon"
  }))), /*#__PURE__*/React.createElement("div", {
    ref: assignRef,
    style: {
      height: height
    },
    className: "accordion__desc",
    "aria-labelledby": buttonId,
    role: "region",
    "aria-hidden": isCollapsed,
    id: containerId,
    tabIndex: `${isCollapsed ? "-1" : "0"}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion__inner"
  }, children)));
};
export default Accordion;